import { render, staticRenderFns } from "./VoilaModule.vue?vue&type=template&id=53c55f3b&scoped=true&"
import script from "./VoilaModule.vue?vue&type=script&lang=js&"
export * from "./VoilaModule.vue?vue&type=script&lang=js&"
import style0 from "./VoilaModule.vue?vue&type=style&index=0&id=53c55f3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c55f3b",
  null
  
)

export default component.exports